import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-nav z-30 flex items-center justify-center fixed top-0 left-0 w-full border-b border-border bg-card h-20" }
const _hoisted_2 = { class: "flex items-center justify-center w-full px-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "border-l border-border pl-3 ml-3" }, "Makler", -1)
const _hoisted_4 = {
  key: 0,
  class: "flex-1 flex justify-end items-center"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Unternehmenseinstellungen")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Abmelden")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_item = _resolveComponent("logo-item")!
  const _component_icon_item = _resolveComponent("icon-item")!
  const _component_avatar_item = _resolveComponent("avatar-item")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openRoute('/'))),
        class: "cursor-pointer flex-1 text-left flex flex-row items-center"
      }, [
        _createVNode(_component_logo_item, {
          class: "h-6",
          type: "logo"
        }),
        _hoisted_3
      ]),
      (_ctx.isSignedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openRoute('/company-profile'))),
              class: "invisible sm:visible w-0 sm:w-auto text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4"
            }, [
              _createVNode(_component_icon_item, {
                path: _ctx.mdiCog,
                size: 16,
                class: "mr-2"
              }, null, 8, ["path"]),
              _hoisted_5
            ]),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "invisible sm:visible w-0 sm:w-auto text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4"
            }, [
              _createVNode(_component_icon_item, {
                path: _ctx.mdiLogoutVariant,
                size: 16,
                class: "mr-2"
              }, null, 8, ["path"]),
              _hoisted_6
            ]),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openRoute('/company-profile'))),
              class: "visible sm:invisible w-auto sm:w-0 text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4"
            }, [
              _createVNode(_component_icon_item, {
                path: _ctx.mdiCog,
                size: 16,
                class: "mr-2"
              }, null, 8, ["path"])
            ]),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "visible sm:invisible w-auto sm:w-0 text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4"
            }, [
              _createVNode(_component_icon_item, {
                path: _ctx.mdiLogoutVariant,
                size: 16,
                class: "mr-2"
              }, null, 8, ["path"])
            ]),
            _createVNode(_component_avatar_item, {
              src: _ctx.profilePicture,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openRoute('/user-profile'))),
              class: "cursor-pointer h-12 w-12"
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}